var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-data-table-container__with_cell_color"},[_c('div',[_c('statistics-page',{attrs:{"operatorId":"exportTelesaleDetail","label":_vm.label,"user":_vm.user,"timeKey":"lastTelesaleStatusUpdatedTime"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }